const ru = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Имя источника обнаружения',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title':
    'Идентификатор пользователя',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL ServiceNow',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Пароль',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Недействительный URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Частота обнаружения',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Предложите пользователям ответить на вопросы об аутентификации на основе знаний (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Узнайте о приложениях и рабочих нагрузках с помощью одного из этих популярных источников обнаружения. Вам также будет доступно предварительное заполнение данных, рекомендации по приоритетам и полный обзор статуса включенного в систему.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Назад',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Настройка обнаружения',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Скоро…',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Подробнее',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Введите учетные данные приложения, чтобы установить соединение. После подключения вы сможете импортировать данные.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'При загрузке страницы произошла ошибка.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Обновите страницу или попробуйте позже. Если проблема не исчезает, обратитесь к администратору.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Перезагрузить',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Настройки подключения',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Классы CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Сопоставление атрибутов',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Сведения о подключении',
  'INTEGRATIONS.BUTTON.SAVE': 'Сохранить',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Выбрать',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Создать подключение',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Использовать это подключение',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow сохранен!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Подключение к источнику обнаружения ServiceNow проверено и сохранено. Импортируйте данные, чтобы завершить настройку обнаружения. Вы можете пропустить…',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Импорт активов',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Пропустить сейчас',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'После запуска импорт невозможно отменить',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Направьте меня',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Выберите существующее соединение',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Имя подключения',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Мы обнаружили {total, plural, one {} other {#}}существующую конфигурацию подключения:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Начать импорт',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Импорт данных из файла Excel. Подождите…',
  'INTEGRATIONS.TRY.AGAIN': 'Повторить попытку',
  'INTEGRATIONS.CLOSE': 'Закрыть',
  'INTEGRATIONS.ERROR.CONNECTION': 'Ошибка подключения. Попробуйте еще раз.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Во время ожидания можно выйти со страницы. После обработки вы получите уведомление по электронной почте.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Импорт источника обнаружения',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Импортируйте источник обнаружения из файла',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Загрузить образец',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Имя источника обнаружения',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Введите имя файла',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Введите допустимое имя. Разрешены только буквы, цифры и некоторые символы.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Выгрузка…',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Продолжить',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Вот первые 10 записей из выгруженного XLSX-файла.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Отсутствует обязательный заголовок',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Обнаружены ошибки в колонках',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Устраните проблемы, прежде чем импортировать данные.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Исключить из импорта',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Подтверждение внедренных приложений',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Мы определили тип приложения. Подтвердите, что это именно тот тип приложения, который вы используете.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Тип приложения, с которым вы работаете: {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Нет, выбрать из списка приложений',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': 'Да, ознакомиться',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Интеграции',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Добавить интеграцию',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Результаты не найдены:',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Нет',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'найденных интеграций.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': 'Нет скрытых интеграций.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Обнаружены приложения',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Владелец:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Последнее обнаружение:',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Ошибка подключения',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'У пользователей есть доступ',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Источник обнаружения',
  'INTEGRATIONS.BUTTON.ENABLE': 'Включить',
  'INTEGRATIONS.BUTTON.DISABLE': 'Выключить',
  'INTEGRATIONS.ENABLING': 'Включение',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Обнаружение',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Повторно выгрузить',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Ознакомление',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Скрыть',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Показать',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Вкладки конфигурации обнаружения',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Сбросить несохраненные изменения?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'У вас есть несохраненные изменения. Изменения будут потеряны, если продолжить.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Сбросить изменения',
  'INTEGRATIONS.BUTTON.CANCEL': 'Отменить',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Ошибка сохранения',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Вернуться на предыдущую страницу',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Значок приложения',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Запуск вручную',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'Ошибка отключения',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Ошибка включения',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION': 'Отключено.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION': 'Включено.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'В настоящее время осуществляется еще один импорт.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'В настоящее время активы импортируются другим процессом. Попробуйте еще раз позже.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'Ошибка импорта',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'Импорт активов из ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Во время ожидания можно выйти со страницы. После завершения вы получите уведомление по электронной почте.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Добавьте новую строку сопоставление атрибутов',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Добавить атрибут',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Пусто)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Удалить сопоставление',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Поле ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Поле Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Поиск атрибута ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Поиск атрибута Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Пользовательский)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Ошибка сохранения',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Конфигурация планирования',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'в {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Повторять',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Повторять по дням',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Повторять кажд.',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Введите интервал',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Интервал повторения в днях, неделях или месяцах',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'День',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Неделя',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Месяц',
  'INTEGRATIONS.DAYS.SUN': 'Вс',
  'INTEGRATIONS.DAYS.MON': 'Пн',
  'INTEGRATIONS.DAYS.TUE': 'Вт',
  'INTEGRATIONS.DAYS.WED': 'Ср',
  'INTEGRATIONS.DAYS.THU': 'Чт',
  'INTEGRATIONS.DAYS.FRI': 'Пт',
  'INTEGRATIONS.DAYS.SAT': 'Сб',
  'INTEGRATIONS.BUTTON.DISABLING': 'Выключение',
  'INTEGRATIONS.BUTTON.SAVED': 'Сохранено',
  'INTEGRATIONS.BUTTON.SAVING': 'Сохранение',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Действительно отключить ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'При отключении источника обнаружения импорт активов будет остановлен и вы не сможете настроить источник.',
  'INTEGRATIONS.DISCOVERY.HERE': 'здесь',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Источник обнаружения создан, но подключение к ServiceNow не установлено. Чтобы импортировать активы, обновите данные о подключении на странице конфигурации источника обнаружения ',
};

export default ru;
